"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayIncludesAll = void 0;
function arrayIncludesAll(arr, requiredArr) {
    if (!Array.isArray(arr) || !Array.isArray(requiredArr)) {
        return false;
    }
    for (const element of requiredArr) {
        if (!arr.includes(element)) {
            return false;
        }
    }
    return true;
}
exports.arrayIncludesAll = arrayIncludesAll;
//# sourceMappingURL=arrayIncludesAll.js.map